// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M17.5,7.3V6c0-0.8-0.7-1.5-1.5-1.5H5.5C4.7,4.5,4,5.2,4,6v8c0,0.8,0.7,1.5,1.5,1.5h3.4L7.4,21h1l1.6-5.5h1.8l1.6,5.5h1
		l-1.6-5.5H16c0.8,0,1.5-0.7,1.5-1.5v-1.3l4,1.5V5.8L17.5,7.3z M20.5,12.8l-4-1.5V14c0,0.3-0.2,0.5-0.5,0.5H5.5
		C5.2,14.5,5,14.3,5,14V6c0-0.3,0.2-0.5,0.5-0.5H16c0.3,0,0.5,0.2,0.5,0.5v2.7l4-1.5V12.8z M2,8h1v4H2V8z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-video-mJ-BeKle.js.map
